import React, { useContext, memo } from 'react';
import { Tab } from 'react-bootstrap';
import ChatContentHeader from './ChatContentHeader';
import ChatContentBody from './ChatContentBody';
import MessageTextArea from './MessageTextArea';
import { ChatContext } from 'context/Context';

const ChatContent = () => {
  const { threads } = useContext(ChatContext);

  return (
    <Tab.Content className="card-chat-content">
      <ChatContentHeader />
      {threads.map((thread, index) => (
        <Tab.Pane key={index} eventKey={index} className="card-chat-pane">
          <ChatContentBody thread={thread} />
        </Tab.Pane>
      ))}
      <MessageTextArea />
    </Tab.Content>
  );
};

export default memo(ChatContent);